<template>
  <div class="modal fade vue-modal" :class="modalCustomCss" tabindex="-1" :style="isShow?'display:block;':'display:none;'">
    <div class="modal-mask" @click.self="close">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" v-show="hasTitle"><slot name="title"></slot></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="modal_text text-center"><slot name="message"></slot></p>
            <slot></slot>
            <div class="modal_bottom">
              <div class="modal_btn_wrapper row justify-content-center">
                <div :class="okButtonCss">
                  <button class="btn primary" :class="buttonCustomCss" @click="clickOK">
                    <span class="btn_text"><slot name="btnOKText">OK</slot></span>
                  </button>
                </div>
                <div v-show="hasCancelBtn" class="col-12 col-sm-4 order-sm-1">
                  <button class="btn cancel" :class="buttonCustomCss">
                    <span class="btn_text"><slot name="btnCancelText">Cancel</slot></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as yup from "yup";

export default {
  name: "PopupModal",
  props: {
    modalSize: {
      type: String,
      validator(value) {
        return ['lg', 'md', 'sm'].includes(value);
      }
    },
    hasCancelBtn: {
      type: Boolean,
      default: false
    },
    hasTitle: {
      type: Boolean,
      default: false
    },
    redirectUrl: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    isShow: false,
  }),

  inject: ['clickOK'],

  methods: {
    open() {
      document.body.classList.add('modal-open');
      this.isShow = true
    },

    close() {
      document.body.classList.remove('modal-open');
      this.isShow = false
    },

    async next() {
      if (this.shouldRedirectAfterOK) {
        console.log("redirectUrl", this.redirectUrl);

        let that = this;
        await yup.string().url().isValid(that.redirectUrl)
            .then(function (valid) {
              console.log("redirectUrl after validator!", valid, that.redirectUrl);
              if (valid) {
                window.location.href = that.redirectUrl;
              }
            });
      }
      this.close();
    }
  },
  computed: {
    modalCustomCss() {
      let show = this.isShow?'show ':'';
      let size = 'bd-example-modal-'+this.modalSize;
      return show+size;
    },
    buttonCustomCss() {
      return (this.modalSize === 'sm') ? 'md' : this.modalSize;
    },
    okButtonCss() {
      return this.hasCancelBtn ? 'col-12 col-sm-4 order-sm-5' : 'col-8';
    },
    shouldRedirectAfterOK () {
      return !!this.redirectUrl && this.redirectUrl.length > 0;
    }
  }
}
</script>